import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AbstractOptionComponent} from '../abstract-option/abstract-option.component';
import {FormsModule} from '@angular/forms';


@Component({
  selector: 'app-text-list-option',
  imports: [
    FormsModule
],
  templateUrl: './text-list-option.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './text-list-option.component.scss'
})
export class TextListOptionComponent extends AbstractOptionComponent {
  text = '';
  values: string[] = [];

  setData(data: any): void {
  }

  getValue(): any {
    return this.values;
  }

  setValue(value: any): void {
    if (Array.isArray(value)) {
      this.values = value.map(value => value.toString());
    } else {
      this.values = [];
    }
  }

  add(): void {
    if (this.text) {
      this.values.push(this.text);
      this.text = '';
    }

    this.onChange();
  }

  remove(text: string): void {
    const i = this.values.indexOf(text);
    if (i > -1) {
      this.values.splice(i, 1);
    }

    this.onChange();
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.add();
    }
  }
}
